import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { Instance } from 'mobx-state-tree'

import { useStores, setPageTitle } from '@trivie/core'
import { color } from '@trivie/ui-web/theme'
import { TopicCard } from '@trivie/ui-mobile'
import { AssignedTopic } from '@trivie/core/src/models/AssignedTopic'

export interface SubscriptionTopicsTabProps {
  contentUserIds: number[]
}

export const SubscriptionTopicsTab = observer((props: SubscriptionTopicsTabProps) => {
  const { libraryStore } = useStores()
  const { topicsSansGeneral } = libraryStore
  const { contentUserIds } = props

  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 })
  const history = useHistory()

  const goToTopic = (topic: Instance<typeof AssignedTopic>) => {
    setPageTitle(`${topic.topic.title} - ${process.env.REACT_APP_SITE_TITLE}`)
    history.push(
      `/library/topic/?subscription_user_id=${topic.metadata.subscription_user_id}&topic_id=${topic.topic.topic_id}&path_id=${topic.metadata.path_id}&content_user_id=${topic.metadata.content_user_id}`,
    )
  }

  function useWindowSize() {
    useEffect(() => {
      function handleResize() {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight })
      }
      window.addEventListener('resize', handleResize)
      handleResize()
      return () => window.removeEventListener('resize', handleResize)
    }, [])
    return windowSize
  }

  useWindowSize()
  function responsiveGrid() {
    if (windowSize.width < 1024) return THINGRID
    else if (windowSize.width < 1440) return NORMALGRID
    else return WIDEGRID
  }

  const filteredData = topicsSansGeneral
    .slice()
    .filter(
      (t) =>
        t.metadata.content_user_id != null && contentUserIds.includes(t.metadata.content_user_id),
    )

  return (
    <div style={CONTENT}>
      <div style={responsiveGrid()}>
        {filteredData.map((topic, index) => (
          <TopicCard
            key={`sub-topic-${index}`}
            // @ts-ignore
            dataSet={{ qat: `sub-topic-card-${index}` }}
            topic={topic}
            onPress={goToTopic}
            hideBg
          />
        ))}
      </div>
    </div>
  )
})

const CONTENT: React.CSSProperties = { backgroundColor: color.white, height: '100%' }
const WIDEGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const NORMALGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
const THINGRID: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gridTemplateRows: '1fr',
  gridGap: 20,
  paddingTop: 0,
  paddingBottom: 20,
}
